import useAccountData from 'hooks/useAccountData';
import { AccessLevel } from 'models/Company';
import { SaleStatusResponse } from 'models/WebShop';
import React, { createContext, useState, useEffect, useContext } from 'react';
import { webShopService } from 'services/Services';


interface OrdersContextType {
  saleStatusByCompany: { [companyId: string]: SaleStatusResponse };
  fetchSaleStatus: (companyId: string) => Promise<void>;
}

const OrdersContext = createContext<OrdersContextType | undefined>(undefined);

export const OrdersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [saleStatusByCompany, setSaleStatusByCompany] = useState<{ [companyId: string]: SaleStatusResponse }>({});
  const { getCurrentCompany } = useAccountData();

  const allowedRoles : AccessLevel[] = [AccessLevel.Phone, AccessLevel.Role, AccessLevel.System, AccessLevel.External];

  const fetchSaleStatus = async (companyId: string) => {
    const company = await getCurrentCompany(companyId);

    if (company === null || !company.accessRoles.some(r => allowedRoles.includes(r))){
      setSaleStatusByCompany(prev => ({
        ...prev,
        [companyId]: { orderStatuses: [], customerNotFound:true, ErrorMessage: "" },
      }));
    }

    const response = await webShopService.getSaleStatus(companyId);
    if (response) {
      setSaleStatusByCompany(prev => ({
        ...prev,
        [companyId]: response,
      }));
    }
  };

  return (
    <OrdersContext.Provider value={{ saleStatusByCompany, fetchSaleStatus }}>
      {children}
    </OrdersContext.Provider>
  );
};


export const useOrders = () => {
  const context = useContext(OrdersContext);
  if (!context) {
    throw new Error('useOrders must be used within an OrdersProvider');
  }
  return context;
};

